import type { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Link(_theme: Theme) {
  return {
    MuiLink: {
      styleOverrides: {
        root: {
          '&:hover': {
            cursor: 'pointer',
          },
          width: 'fit-content',
        },
      },
      defaultProps: {
        underline: 'hover',
      },
    },
  };
}
